
import DocumentExportForm from './document-export-form'

export default {
  box: DocumentExportForm,
}
